import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GridService {
    async handleDataGridRow<T>(input: T, action: (item: T) => Promise<T>, output?: Partial<T>): Promise<boolean> {
        try {
            const saved = await action(input);
            Object.assign(output || input, saved || {});
            return !saved;
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            throw error.error?.title || error.error || error.message;
        }
    }
}
